export class WindcaveData {
    windcaveIds: string[] = [];
    lastId?: number;
    windcaveAccounts: { [key: string]: WindcaveAccount } = {};

    constructor(windcaveData?: WindcaveData) {
        if (windcaveData) {
            this.windcaveIds = windcaveData.windcaveIds || [];
            this.windcaveAccounts = windcaveData.windcaveAccounts || {};
        } else {
            this.windcaveIds = [];
            this.windcaveAccounts = {};
        }
    }
}

export class WindcaveAccount {
    windcaveId: string;
    nickname: string;
    username: string;
    apiKey: string;

    constructor(windcaveAccount?: WindcaveAccount) {
        if (windcaveAccount) {
            this.apiKey = windcaveAccount.apiKey || "";
            this.nickname = windcaveAccount.nickname || "";
            this.username = windcaveAccount.username || "";
            this.windcaveId = windcaveAccount.windcaveId || "";
        } else {
            this.apiKey = "";
            this.nickname = "";
            this.username = "";
            this.windcaveId = "";
        }
    }
}

// Revisit this
export class WindcaveAccountCreationData {
    clientId?: string;
    nickname: string;
    code: string;

    constructor(code: string) {
        this.nickname = "Windcave Account - " + Math.random().toString(36).substring(2, 7);
        this.code = code;
    }
}